import { db } from "@modules/local/db";
import { setStorage } from "@modules/storage/storageHelper";
import { Language, SetCurrentLanguage } from "./i18n";

export const changeLanguage = async (
  language: Language,
  rerenderApp = true
) => {
  SetCurrentLanguage(language);

  setStorage({
    key: "LANGUAGE",
    data: {
      language: language,
    },
  });

  await db.delete({ disableAutoOpen: false });

  // It's neccessary to rerender the entire app by doing browser navigation
  // so all on mount useEffects get run again
  if (rerenderApp) {
    document.location.assign(document.location.origin + "/");
  } else {
    // This else is for when the language change happens before app mount
    // or in other words on logout
    document.documentElement.setAttribute(
      "dir",
      language === "ar" ? "rtl" : "ltr"
    );
    document.documentElement.setAttribute("lang", language);
  }
};
